<div class="simple-view-element" [class.d-none]="hideIfNoTextContent && content.textContent.trim().length === 0">
  <h2 class="simple-view-element-header" *ngIf="label">{{ label }}</h2>
  <div #content class="simple-view-element-body">
    <ng-content></ng-content>
  </div>
</div>
